export default function GitHub_Add_SSH() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">GitHub Add SSH</h1>

      <p className="mt-4 text-gray-500 text-sm">Path: /git/github/add-ssh</p>
    </div>
  );
}
